import storyblokRuntime_36ee4oN6fo0KAK0lcQZqQDwafSxClc3K1TnLeoaoXpnAc from '/app/node_modules/@nuxt/image/dist/runtime/providers/storyblok'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"storyblok"} */
  provider: "storyblok",
  providers: {
      ['storyblok']: { setup: storyblokRuntime_36ee4oN6fo0KAK0lcQZqQDwafSxClc3K1TnLeoaoXpnAc, defaults: {"baseURL":"https://assets.pflege.de"} }
  }
}
